import React, { useCallback, useEffect } from 'react';
import { Modal, Button } from '@livecommerce/design-system';
import { ProductUpdates } from './ProductUpdates.jsx';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import useProductUpdates from 'hooks/useProductUpdates.jsx';
import { trackingService } from 'services/tracking/TrackingService.js';

const ProductUpdatesModal = ({ isOpen = false, onClose = () => {} }) => {
  const { t } = useLocalization();
  const { setSeenItems } = useProductUpdates();

  const onCloseAndSetSeen = useCallback(() => {
    onClose();
    trackingService.track({ eventType: 'product-updates-modal:close' });
    setSeenItems();
  }, [ onClose, setSeenItems ]);

  useEffect(() => {
    if (isOpen) {
      trackingService.track({ eventType: 'product-updates-modal:open' });
    }
  }, [ isOpen ]);

  return (
    <Modal
      name="product-updates-modeal"
      isModalOpen={isOpen}
      onClose={onCloseAndSetSeen}
      variant="confirmation"
      title={t('productUpdates.title')}
      width={1000}
      actions={
        <Button variant="hollow" onClick={onCloseAndSetSeen}>
          {t('genericLabels.close')}
        </Button>
      }
    >
      <ProductUpdates />
    </Modal>
  );
};

export default ProductUpdatesModal;
